import React from "react";

import "../../style/descriptionBox.css";

export default function DescriptionBox(props: { bookInfo: any }) {
  const openTab = (tabClassName: string) => {
    let i;

    const tabContents = document.getElementsByClassName("TabContent");
    const tabButtons = document.getElementsByClassName("TabButton");
    for (i = 0; i < tabContents.length; i++) {
      if (tabContents[i].classList.contains("active")) {
        tabContents[i].classList.remove("active");
      }
      if (tabButtons[i].classList.contains("active")) {
        tabButtons[i].classList.remove("active");
      }
    }

    const elements = document.getElementsByClassName(tabClassName);
    for (i = 0; i < elements.length; i++) {
      elements[i].classList.add("active");
    }
  };

  return (
    <>
      <div className="BookTabs">
        <span className="TabButton BookSummary active" onClick={() => openTab("BookSummary")}>
          Beskrivelse
        </span>
        <span className="TabButton AuthorsInfos" onClick={() => openTab("AuthorsInfos")}>
          Forfatterinformasjon
        </span>
      </div>
      <div className="TabContent BookSummary active">{props.bookInfo.Summary}</div>
      <div className="TabContent AuthorsInfos">
        {props.bookInfo.AuthorsInfos.map((authorInfo: { [key: string]: any }, index: number) => (
          <>
            {authorInfo.Description && (
              <div className="AuthorBox" key={index}>
                {authorInfo.ImageUrl && (
                  <div className="AuthorImageContainer">
                    <img className="AuthorImage" src={authorInfo.ImageUrl} alt={authorInfo.Name + " image"} />
                  </div>
                )}
                <div className="AuthorInfo" dangerouslySetInnerHTML={{ __html: authorInfo.Description }}></div>
              </div>
            )}
          </>
        ))}
      </div>
    </>
  );
}
